import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../theme';
import DescriptionBlock from '../DescriptionBlock/DescriptionBlock';
import SwitchBlock from '../SwitchBlock/SwitchBlock';
import Money from '../../../Money';
import { WxEvents } from '../../../DataLayerAnalytics/types';
import { useEffect, useMemo } from 'react';
import WebskyAnalyticsApollo from '../../../DataLayerAnalytics/WebskyAnalyticsApollo';
import cn from 'classnames';
import { useConfig } from '../../../context';
import { SafeHtml } from '@shared/ui';
const ConfirmOption = ({ onChange, price, addedToOrder, confirmed, freezeUntil, variant, service, isActive, isDisabled, isOld: isOldFromProps, isLoading }) => {
    const { FareLock: css } = useTheme('FareLock');
    const { t } = useTranslation('FareLock');
    const { isOldConfirmOption } = useConfig().global;
    const isOld = isOldFromProps !== null && isOldFromProps !== void 0 ? isOldFromProps : isOldConfirmOption;
    const getTitle = useMemo(() => {
        var _a;
        let title = '';
        switch (variant) {
            case 'FareLock':
                if (addedToOrder) {
                    title = t('Check your selection and pay fare lock');
                }
                else if (confirmed) {
                    title = t('Confirmed fare lock');
                }
                else {
                    title = t('Fixation the cost of the air ticket');
                }
                break;
            case 'Refund':
                title = ((_a = service === null || service === void 0 ? void 0 : service.name) === null || _a === void 0 ? void 0 : _a.length) ? service.name : t('Ticket Refund Option Available');
                break;
            case 'Upgrade':
                title = t('UpgradeFlightClass:Get upgraded now!');
                break;
            case 'Note':
                title = t('Please note:', { nsSeparator: '|' });
                break;
        }
        return (React.createElement(React.Fragment, null,
            title,
            confirmed && price && (React.createElement(React.Fragment, null,
                ": ",
                React.createElement(Money, { money: price })))));
    }, [variant, addedToOrder, confirmed, service === null || service === void 0 ? void 0 : service.name, price]);
    const getDescription = useMemo(() => {
        let description = '';
        switch (variant) {
            case 'FareLock':
                description = addedToOrder
                    ? t('If you make the decision to fly on the selected date within the next {{hours}} {{plural}}, you will be able to pay the full amount of the booking at the fare you locked in. Please, be advised that Fare lock fee is non-refundable.', {
                        hours: freezeUntil,
                        plural: t('hours', { count: freezeUntil })
                    })
                    : t('No need to worry about the price increase or about the fact that all tickets will be sold out, now you can fix the ticket price for {{hours}} {{plural}}', {
                        hours: freezeUntil,
                        plural: t('hours', { count: freezeUntil })
                    });
                break;
            case 'Refund':
                description =
                    (service === null || service === void 0 ? void 0 : service.description) ||
                        t('You can get a full refund for your ticket if you have more than 24 hours left before departure. Add the service now — it will be unavailable later.');
                break;
            case 'Upgrade':
                description = service === null || service === void 0 ? void 0 : service.description;
                break;
            case 'Note':
                description = t('to manage bookings made on the SCAT International website, it is necessary to use this <a href="https://scat.international.tickets.kz/orders/avia" target="_blank">link</a>', { nsSeparator: '|' });
                break;
            default:
                break;
        }
        return React.createElement(SafeHtml, { tag: "div", html: description });
    }, [variant, service === null || service === void 0 ? void 0 : service.description, freezeUntil, addedToOrder]);
    useEffect(() => {
        if (!addedToOrder) {
            WebskyAnalyticsApollo.dispatchWxViewEvent(WxEvents.PriceFreeze);
        }
    }, [price === null || price === void 0 ? void 0 : price.amount, confirmed]);
    return (React.createElement("div", { className: cn(css.root, {
            [css.root_old]: isOld,
            [css.root_disabled]: isDisabled,
            [css.root_refund]: variant === 'Refund',
            [css.root_fareLock]: variant === 'FareLock',
            [css.root_upgrade]: variant === 'Upgrade',
            [css.root_note]: variant === 'Note'
        }) },
        React.createElement(DescriptionBlock, { variant: variant, showConfirmedIcon: confirmed, title: getTitle, description: getDescription, isOld: isOld, isDisabled: isDisabled }),
        !addedToOrder && !['Upgrade', 'Note'].includes(variant) && (React.createElement(SwitchBlock, { price: price, isActive: isActive, isDisabled: isDisabled, onChange: onChange, variant: variant, isOld: isOld, isLoading: isLoading }))));
};
export default ConfirmOption;
